import React from 'react';

import Login from '@features/login/Login.tsx';

interface ComponentProps {}

const LoginPage: React.FC<ComponentProps> = () => {
  return (
    <>
      <Login />
    </>
  );
};

export default LoginPage;
